// extracted by mini-css-extract-plugin
export default {"page":"styles_page__gON4f","workAssignments":"styles_workAssignments__0d2x1","selector":"styles_selector__jpfeI"};